import { QIcon_book, QIcon_clock, QIcon_logo, QIcon_printer, QIcon_tutor_monitor } from '@repo/icons/index'
import ReactToPrint from 'react-to-print'
import { ILesson } from '../../../../model/lesson.interface'
import { n_lesson_review } from '../../../../modules/i18n/strings/auto/wording'
import useTranslation from '../../../../modules/i18n/useTranslation'
import { COLORS } from '../../../../modules/vars'

interface LessonInfoProps {
  lesson: ILesson
  reportRef: any
}
const ReportLessonInfo = ({ lesson, reportRef }: LessonInfoProps) => {
  if (!lesson) return
  const courseTitle = lesson.course.title
  const timeString = lesson.formatted_start_time
  const tutorName = lesson?.tutor?.name
  return (
    <div className="mt-[20px] flex flex-col items-center justify-between pb-[24px] sm:flex-row">
      <LogoAndPrint reportRef={reportRef} />
      <LessonInfo timeString={timeString} tutorName={tutorName} courseTitle={courseTitle} />
    </div>
  )
}
const LogoAndPrint = ({ reportRef }: { reportRef: any }) => {
  return (
    <div className="sm:border-r-1 border-b-1 flex w-full flex-col items-start justify-start border-r-0 border-gray-200 pb-[11px] pr-[162px] sm:w-auto sm:border-b-0 sm:pr-[40px] sm:pb-0 lg:pr-[162px]">
      <QIcon_logo width={74} height={24} />
      <div className="text-16px mt-[4px] text-gray-600">Tutor's Feedback Report'</div>
      <div className="flex h-[30px] lg:hidden"></div>
      <ReactToPrint
        pageStyle="p-32"
        trigger={() => (
          <div className="mt-[14px] hidden cursor-pointer flex-row items-center justify-start lg:flex">
            <QIcon_printer width={16} height={16} />
            <span className="text-[14px] font-bold text-black">Print</span>
          </div>
        )}
        content={() => reportRef.current}
      />
    </div>
  )
}
const LessonInfo = ({
  timeString,
  tutorName,
  courseTitle,
}: {
  timeString: string
  tutorName: string
  courseTitle: string
}) => {
  const { t } = useTranslation()
  return (
    <div className="flex w-full flex-1 flex-col items-start justify-start px-[16px] pt-[16px] sm:pt-0">
      <div className="flex flex-row items-center justify-start">
        <div className="mr-[16px] flex w-[120px] flex-row items-start justify-start">
          <QIcon_clock width={16} height={16} className="mr-[4px]" color={COLORS.GRAY500} />
          <div className="text-[14px] text-black">{t(n_lesson_review.feedback_time)}</div>
        </div>
        <div className="keep-all flex-1 text-[14px] font-bold text-black">{timeString}</div>
      </div>

      <div className="mt-[12px] flex flex-row items-start justify-start">
        <div className="mr-[16px] flex w-[120px] flex-row items-center justify-start">
          <QIcon_tutor_monitor width={16} height={16} className="mr-[4px]" color={COLORS.GRAY500} />
          <div className="text-[14px] text-black">{t(n_lesson_review.feedback_tutor)}</div>
        </div>
        <div className="keep-all flex-1 text-[14px] font-bold text-black">{tutorName}</div>
      </div>

      <div className="mt-[12px] flex flex-row items-start justify-start">
        <div className="mr-[16px] flex w-[120px] flex-row items-center justify-start">
          <QIcon_book width={16} height={16} className="mr-[4px]" color={COLORS.GRAY500} />
          <div className="text-[14px] text-black">{t(n_lesson_review.feedback_material)}</div>
        </div>
        <div className="keep-all flex-1 text-[14px] font-bold text-black">{courseTitle}</div>
      </div>
    </div>
  )
}
export default ReportLessonInfo
